/**
 * FAQ data - April 2025 (SLM/KLM)
 * Source: faq-satyam.docx
 */

export const faqCategories = [
  {
    id: "flight",
    title: "Flight information (SLM/KLM)",
    questions: [
      {
        q: "What do 2nd and 3rd baggage cost at SLM/KLM? What about seat costs for economy and business?",
        a: "SLM — Second baggage: €85/US$85 per passenger per one-way. Third baggage: €185/US$185 per passenger per one-way. Economy seat: €40/USD. Preferred seat: €85. Business: free if they have a business ticket. KLM — Varies; we can only check once we have the booking reference. Economy seat: €40. Row of 2: €55. Standard front seat: €75. Economy Comfort: €105. Premium Economy: €90 (unless customer has Premium Economy Light/Standard). Business: €190 (unless customer has Business Light/Standard).",
      },
      {
        q: "Does SLM online check-in work?",
        a: "Online check-in for SLM is available 24 hours before departure via the SLM App. The website sometimes still has issues, occasionally with date of birth.",
      },
      {
        q: "Do SLM/KLM have seats with extra legroom?",
        a: "SLM does not have seats with extra legroom. KLM does, in the Premium Comfort class.",
      },
      {
        q: "When can I check in for SLM/KLM?",
        a: "SLM: 24 hours before departure. KLM: 30 hours before departure.",
      },
      {
        q: "What are the medical baggage allowances for KLM and SLM?",
        a: "SLM: Max 5 kg extra (cabin & hold). For return, a new request must be made with remaining kg. KLM: Max 12 kg extra in cabin or max 23 kg in hold. A medical passport or doctor's certificate is required. For return, request at least 3 days before departure with remaining kg. Same amount as outbound may not be accepted. We need the medical passport in both cases.",
      },
      {
        q: "When is the latest I can pay for extra baggage?",
        a: "At least 3 days before departure for both SLM and KLM.",
      },
      {
        q: "What are the check-in times for flights?",
        a: "Latest 3 hours before departure.",
      },
      {
        q: "Do you get labels for your luggage?",
        a: "Stickers may be available at the airport; you can ask the desk staff.",
      },
      {
        q: "Is there a difference between comfort seats and extra legroom at SLM?",
        a: "SLM has neither comfort nor extra legroom seats—only preferred seats.",
      },
      {
        q: "Customer has 2x baggage on outbound and 1x on return—what to do with 2nd bag on return?",
        a: "The customer can combine hold luggage for the outbound and travel with one piece. If not desired, they can purchase extra baggage for the return.",
      },
      {
        q: "Customer had no entertainment or blanket on SLM—can they get compensation?",
        a: "Unfortunately not. That is decided by the airline.",
      },
      {
        q: "What can passengers bring to the Netherlands with SLM/KLM?",
        a: "Passengers can consult the customs website: https://www.belastingdienst.nl/wps/wcm/connect/nl/bagage/content/wat-mag-ik-niet-meenemen-naar-nederland",
      },
      {
        q: "When will SLM fly with their new aircraft?",
        a: "We cannot answer that—only the airline can provide that information.",
      },
      {
        q: "Are SLM flights guaranteed?",
        a: "Flights are not always guaranteed. Delays can occur for various reasons; customers are compensated for delays.",
      },
      {
        q: "What can be done with the €25 SLM voucher? Where and how is it redeemed?",
        a: "The voucher can only be used with SLM for seat or baggage purchase.",
      },
      {
        q: "How can customers check flight status?",
        a: "They can contact us or check the airline's website.",
      },
      {
        q: "Information about flights to São Paulo?",
        a: "For fares to São Paulo, visit our website: www.satyamtours.nl",
      },
    ],
  },
  {
    id: "visa",
    title: "Visa",
    questions: [
      {
        q: "If US visa is still valid and passenger has new passport, can they travel with that visa?",
        a: "Yes. The customer can travel with both—the old passport with the visa and the new passport for validity.",
      },
      {
        q: "What documents are needed for NL or USA visa application?",
        a: "USA: DS-160 form (€25/$25 p/p), passport photo 50x50mm, travel itinerary, family booklet copy, KKF extract, school/work statement, salary slips, hotel/guarantee letter from USA, proof of prior US visas, current visas of household members. Visa fee $225. NL: Valid passport (6+ months), objection letter if minors not traveling with parents, school statement (MINOV), employer statement, family booklet/CBB extract, KKF if self-employed, salary slips and bank statements (3 months), copies of ID, old visas, passport. Insurance: 0–69 yrs €1.22/day + €3 policy fee; 70–79 yrs €5.40/day; 80–100 yrs €8.78/day. Visa fees: Adults €125, 6–11 yrs €85, under 6 €45. Saturday appointment: +€20 weekend surcharge.",
      },
      {
        q: "What are the visa fees at the embassy?",
        a: "NL: Adults €125, 6–11 yrs €85, under 6 €45. USA: $225 (wire transfer).",
      },
      {
        q: "Requirements for MVV application?",
        a: "We only make appointments. Passport and contact number are required. The application is submitted to IND in the Netherlands.",
      },
      {
        q: "USA drop-off requirements and procedure?",
        a: "Valid passport, original passport with old visa, recent photo 5x5 cm, original family booklet, completed DS-160 form (we assist; $25 p/p). Total $235. Eligible if: resident of Suriname or French Guiana, visa issued in Suriname, visa not expired more than 12 months, 14+ years old at last visa issuance.",
      },
      {
        q: "Can I buy a ticket before I get my visa?",
        a: "Yes, but at your own risk. If the visa is refused, refund can be requested with a refusal letter; about €100–200 may be withheld.",
      },
      {
        q: "Within how long can a US visa be renewed?",
        a: "If not expired more than 1 year: drop-off renewal. If longer: new interview appointment required.",
      },
      {
        q: "India visa procedure and costs?",
        a: "Requirements: ticket (if not booked with us), passport scan, photo scan, completed form, contact details. If previously visited India: address and old visa number. India Visa €60 (1 year) or €110 (5 years). Satyam assists but is not responsible for the final decision by Indian authorities.",
      },
      {
        q: "Why does drop-off take so long?",
        a: "The duration depends entirely on the US Embassy and available appointment dates.",
      },
      {
        q: "Belgium visa requirements? Where is it submitted?",
        a: "Same procedure as NL visa, via VFS Global. Same requirements as NL; only the guarantee letter differs.",
      },
      {
        q: "Do you do Canada visa? What are the requirements?",
        a: "Canada visa applications are currently on hold. We will announce when they are available again.",
      },
      {
        q: "What does the customer need to make a reservation?",
        a: "A clear photo of the passport with barcode (without finger on it) and an email address are essential.",
      },
      {
        q: "Requirements for VFS appointment?",
        a: "Passport photo with barcode clearly visible, desired appointment period and travel plans, contact details (phone and email).",
      },
      {
        q: "Dubai visa requirements?",
        a: "Passport scan (colour PDF), passport photo (colour PDF), hotel reservation (PDF) with all passengers' names, ticket (PDF), birth certificate for minors. Apply 14–30 working days before departure. Processing ~1 week. Single entry: $160 (if hotel/ticket with us) or $185. Multiple entry: $250 or $275. Requirements: Min $900/€900/Dh3,000 cash or card, return ticket, accommodation proof.",
      },
    ],
  },
  {
    id: "passport",
    title: "Passport",
    questions: [
      {
        q: "If passport is valid for 3 months and customer travels for 3 weeks, is that OK?",
        a: "Passport must be valid for at least 6 months at departure. For return before expiry it's fine, but must return before expiration.",
      },
      {
        q: "How long must a passport be valid for visa application?",
        a: "Minimum 6 months.",
      },
      {
        q: "How long must passports be valid to travel?",
        a: "Minimum 6 months.",
      },
      {
        q: "Do you provide passport holders?",
        a: "Satyam does not currently provide passport holders. We will announce when they are available again.",
      },
    ],
  },
  {
    id: "entry-fee",
    title: "Entry fee & PSA",
    questions: [
      {
        q: "Can I apply for entry fee / PSA visa through you?",
        a: "Yes, it is possible to apply through us.",
      },
      {
        q: "What are the costs?",
        a: "PSA: €130 adults, €80 children. Requirements: passport photo, recent photo, birth certificate, marital status docs, phone, address, postcode. Processing 6–8 weeks at consulate. Entry voucher: clear passport photo, valid email and phone, departure date, ticket copy (if not booked with us). Passport must be valid 6+ months. Voucher valid 90 days from issue. Entry fee: €70 per person.",
      },
      {
        q: "When can I expect these documents?",
        a: "Entry fee: requested min 1 month before departure, received within hours. PSA: processing 6–8 weeks, can be longer.",
      },
      {
        q: "Does the Entry Fee apply to those born in Suriname?",
        a: "If someone born in Suriname holds a non-Surinamese passport, the Entry Fee applies.",
      },
    ],
  },
  {
    id: "vaccination",
    title: "Vaccination & bookings",
    questions: [
      {
        q: "Do I still need vaccination to travel to Suriname?",
        a: "If traveling from countries in the region to Suriname, vaccination is required.",
      },
      {
        q: "Which countries require yellow fever vaccination?",
        a: "Countries in the region require vaccination.",
      },
      {
        q: "Do we get a discount on group bookings?",
        a: "For groups of at least 10 people we may offer a discount.",
      },
      {
        q: "Why book via the website if you can help via WhatsApp?",
        a: "Customers can see the most current fares, which is important given possible fluctuations.",
      },
      {
        q: "For which countries is yellow fever vaccination mandatory?",
        a: "For travelers from Suriname to countries in the region, yellow fever vaccination may be mandatory.",
      },
      {
        q: "Do we still need to be vaccinated to travel?",
        a: "For travelers from Suriname to the region, yellow fever vaccination may be required.",
      },
      {
        q: "Is vaccination transfer sufficient?",
        a: "Transfer is only possible at the Bureau for Public Health (BOG). A BOG-issued vaccination certificate is sufficient.",
      },
    ],
  },
  {
    id: "pcr",
    title: "PCR test",
    questions: [
      {
        q: "Is a PCR test still required?",
        a: "During COVID it was mandatory; it is no longer required.",
      },
      {
        q: "Where can I get a PCR test?",
        a: "A PCR test is no longer required.",
      },
      {
        q: "What is the difference between PCR and antigen test?",
        a: "Neither is required anymore.",
      },
    ],
  },
  {
    id: "children",
    title: "Traveling with babies & children",
    questions: [
      {
        q: "Where can I request a baby basket?",
        a: "When you book through us, we can arrange the baby basket request for you.",
      },
      {
        q: "Can I choose a seat in advance?",
        a: "Yes, but there are costs involved.",
      },
      {
        q: "Does a baby get a seat?",
        a: "If you want the baby to sleep in a separate seat, book the baby as a child. By default, babies do not have their own seat.",
      },
      {
        q: "Do children aged 2–3 get a seat?",
        a: "Children 2 years and older are entitled to their own seat.",
      },
      {
        q: "What are the baggage allowances for babies and children?",
        a: "KLM: Baby (under 2, lap): hold 1×10 kg, cabin 1×12 kg. Child (2+): hold 1×23 kg, cabin 1×12 kg. SLM: Baby: hold 1×10 kg, cabin 1×10 kg. Child (2+): hold 1×25 kg, cabin 1×10 kg.",
      },
    ],
  },
  {
    id: "fares",
    title: "Fares, exchange & cancellations",
    questions: [
      {
        q: "What are the fares for ... period?",
        a: "For complete and current fares, please visit our website: www.satyamtours.nl",
      },
      {
        q: "Do I get a refund if the airline cancels my flight?",
        a: "Refund can be requested when the airline cancels. Each airline has its own rules.",
      },
      {
        q: "What exchange rate do you use? Why is it higher than elsewhere?",
        a: "We use the current DSB exchange rate at the time of payment.",
      },
      {
        q: "Why are your fares sometimes higher than other agencies?",
        a: "We guarantee our prices match airline fares; a higher price from us is not possible.",
      },
      {
        q: "Why do fares change so quickly?",
        a: "Fares depend on availability and are subject to change.",
      },
      {
        q: "What happens if the airline cancels? Is the ticket refunded?",
        a: "If the customer decides to cancel, a refund can be requested. The final decision lies with the airline.",
      },
    ],
  },
  {
    id: "tickets",
    title: "Tickets, extra baggage & medical",
    questions: [
      {
        q: "I bought a ticket online—can Satyam change it?",
        a: "Yes. We need the booking reference, last name, first name, and desired change date.",
      },
      {
        q: "Can I buy extra baggage for an online ticket through you?",
        a: "Yes, but it must be done at least 3 days before departure.",
      },
      {
        q: "Can I request medical baggage through you?",
        a: "Yes. We need the medical passport in both cases.",
      },
      {
        q: "Can I request a medical device?",
        a: "Yes. We need dimensions (L×W×H) and brand. It is used on board but must be declared by the passenger.",
      },
      {
        q: "What are the fares for extra baggage?",
        a: "SLM: Second baggage €85/US$85 per passenger per one-way. Third: €185/US$185. KLM: varies by booking.",
      },
      {
        q: "Is a return ticket cheaper than one-way?",
        a: "Usually yes—a return ticket is often cheaper.",
      },
      {
        q: "When and how does online check-in work?",
        a: "SLM: 24 hours to 5 hours before departure via SLM app. KLM: 30 hours to 1 hour before departure via KLM.nl.",
      },
    ],
  },
  {
    id: "assistance",
    title: "Assistance",
    questions: [
      {
        q: "Who can get wheelchair assistance?",
        a: "Assistance can be requested if the passenger can provide valid proof.",
      },
      {
        q: "Can I get assistance when traveling with a baby or children?",
        a: "Unfortunately not—you are also accompanying the children.",
      },
    ],
  },
  {
    id: "actions",
    title: "Actions, changes & amounts",
    questions: [
      {
        q: "Are there any promotions at the moment?",
        a: "Follow our social media for the latest offers.",
      },
      {
        q: "Can I change my ticket?",
        a: "Yes, as long as your ticket conditions allow it.",
      },
      {
        q: "What is the maximum amount of cash a customer can bring?",
        a: "Per person the limit is $10,000. Above that, you must prove the origin of the funds.",
      },
      {
        q: "Are change costs the same as the ticket difference?",
        a: "Total = Ticket difference + Change fee + Service fee.",
      },
    ],
  },
  {
    id: "insurance",
    title: "Travel insurance",
    questions: [
      {
        q: "How many days before must I cancel my insurance?",
        a: "The policy must be cancelled before the start date.",
      },
      {
        q: "Do I get a refund if my visa is refused?",
        a: "If the policy has not yet started, with a refusal letter you get a refund minus admin costs. Once the policy has started, no refund is possible.",
      },
      {
        q: "What are the travel insurance costs for NL?",
        a: "0–69 yrs: €1.22/day; 70–79 yrs: €5.40/day; 80–100 yrs: €8.78/day + one-off €3 policy fee.",
      },
    ],
  },
  {
    id: "cruise",
    title: "Cruise, tours, guide & hotel",
    questions: [
      {
        q: "Can hotels be checked?",
        a: "We need your preferences: number of people, room layout, ages, whether you want breakfast.",
      },
      {
        q: "Can a guide be arranged?",
        a: "Yes, a guide can be present during the tours.",
      },
      {
        q: "Are there tours to Aruba and Curaçao?",
        a: "We can create a custom tour based on your preferences.",
      },
    ],
  },
  {
    id: "payments",
    title: "Payments & bank costs",
    questions: [
      {
        q: "Are there bank costs for cash payments?",
        a: "Yes. For cash payments there is a 1.05% bank cost on the indicated non-cash rate.",
      },
      {
        q: "Transfer to the same bank (e.g. DSB to DSB)?",
        a: "We advise transferring within the same bank so the payment is credited immediately. Please include the booking code in the description.",
      },
      {
        q: "Can we pay in SRD at your agency?",
        a: "Yes, we accept SRD at the applicable exchange rate.",
      },
    ],
  },
];
